import {
  CircularProgress,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
} from '@chakra-ui/react';
import ChangePlanModalHeader from './components/ChangePlanModalHeader';
import Confirmation from './components/Confirmation';
import Selection from './components/Selection';
import { useChangePlanModalContext } from './ModalContext';

interface ChangePlanModalProps {
  isOpen: boolean;
  onClose(): void;
}

const ChangePlanModal: React.FC<ChangePlanModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { step, loading } = useChangePlanModalContext();

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="xl">
      <DrawerOverlay />

      <DrawerContent pos="relative">
        <DrawerCloseButton />
        <ChangePlanModalHeader />

        {step === 0 && <Selection onClose={onClose} />}
        {step === 1 && <Confirmation onClose={onClose} />}

        {loading && (
          <Flex
            pos="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            bg="gray.100"
            zIndex="1"
            align="center"
            justify="center"
          >
            <CircularProgress isIndeterminate color="yooga.400" />
          </Flex>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default ChangePlanModal;
